import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {AppEntry, Customization} from '@eduvision/toolkit';

import reportWebVitals from './reportWebVitals';
import * as customization from './customization';


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);


root.render(
	<AppEntry customization={customization as Customization} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
